import {config} from 'config/env/index';
import {ComplexPromotionType} from 'utils/recommendation-utils/proPointsPromotion.util';

// Firebase web feature flag which already turnned on
export const shopping1PNextDayEnabled = true;
export const weightedFreshPhase3Enabled = true;
export const isEnable3POwnFleet = true;
export const isNewEndPoint = true;

// Doppler flag
export const isBasketDiversifyFlagEnabled = config.ENABLE_BASKET_DIVERSIFY;
export const isEnabledRecommendationMFE = config.ENABLED_BASKET_RECOMMENDATION_MFE;

// Static variable
export const allowAlcohol = true;
export const isPDPRevamp = true;
export const enableBrandDetails = true;
export const shouldFetchDeliveryDescription = true;
export const enableSellInPiece = true;
export const enable1PX = true;
export const webEnableDiscontinuedItem = true;
export const loyaltyProductPDPEnabled = true;

export const isDisabledButAllowedToOrderForAS = false;
export const isRecommendationCarousel = true;
export const showOnlyAddToCartButton = false;
export const AS_HALF_PRODUCT_QUANTITY = 0.5;
export const removeImageSkeleton = false;
export const isShowAddtoCartBtn = true;
export const recommendationVariant = config.RECOMMENDATION_VARIANT;
export const PROMOTION_SUGGESTION_TARGET_UNIT = 'UNIT';
export const PRODUCT_TYPE_1P = '1P';
export const PRODUCT_TYPE_3P = '3P';
export const apiVersion = '?apiVersion=20230109';
export const CURRENCY_CODES = {
  THB: 'THB'
};
export const CONTENT_TYPES = {
  PRODUCT: 'product'
};
export const BASKET_RECOMMENDATION_PAGE_SIZE = 20;

export const SEARCH_PERFORM_TRIGGER_TYPE = {
  SEE_ALL: 'seeAll',
  ENTER: 'enter',
  DIRECT_CLICK: 'directClick',
  HISTORY_CLICK: 'historyClick',
  PLUS_BUTTON: 'plusButton',
  QUANTITY_COUNT: 'quantityCount',
  PRODUCT_CARD: 'productCard',
  SEE_ALL_CARD: 'seeAllCard'
};

export enum CarouselEventMessagesType {
  IFRAME_READY = 'IFRAME_READY',
  NAVIGATE_PDP_PAGE = 'NAVIGATE_PDP_PAGE',
  SEE_ALL = 'SEE_ALL',
  CAROUSEL_EMPTY = 'CAROUSEL_EMPTY'
}

export enum PdpWebviewEvents {
  HANDLE_INCREMENT = 'HANDLE_INCREMENT',
  HANDLE_DECREMENT = 'HANDLE_DECREMENT'
}

export const BASKET_RECOMMENDATION_CAROUSEL_NAME = {
  personalised: 'Recommended for you',
  custom: 'Valued from Bestsellings',
  custom3p: 'Valued From Top Sellers'
};

export const PRODUCT_CARD_CONSTANTS = {
  IMAGE_SCALE_FACTOR: 0.75
} as const;

export const LOYALTY_AND_CAMPAIGN_CDN_FILE_NAMES = {
  confetti3dIcon: 'confetti3dIcon.png',
  congratulationsWelcomeCampaign: 'congratulationsWelcomeCampaign.png',
  withHoldingTaxDownloadIcon: 'documentScanner.png',
  ellipseBackground: 'ellipseBackground.png',
  emptyVoucherIcon: 'loyaltyVoucherEmpty.png',
  giftWrapRed: 'loyaltyRewardGiftRedBox.png',
  jadhaiPlusLogo: 'jadhaiPlusLogo.png',
  loyaltyDashboardHeaderCoin: 'loyaltyDashboardHeaderCoin.png',
  loyaltyIntro: 'loyaltyIntro.png',
  loyaltyLedgerNoPoints: 'loyaltyLedgerNoPoints.png',
  loyaltyPointsTag: 'loyaltyPointsTag.png',
  loyaltyRewardVouchersPair: 'loyaltyRewardVouchersPair.png',
  newPoint: 'newPoint.png',
  noCampaignSpendingHistory: 'noCampaignSpendingHistory.png',
  noProPointsPromotionsIcon: 'noProPointsPromotionsIcon.png',
  productAdjustWarning: 'productAdjustWarningIcon.png',
  productUnavailable: 'productUnavailable.png',
  rewardCenterHeader: 'rewardCenter.png',
  voucherRedeemSuccess: 'voucherRedeemSuccess.png',
  zoomIcon: 'zoomIcon.png',

  // INFO: below tier icon file names are not using camel case as they are used in the backend and should not be changed
  // As silver tier and platinum tier svgs are larger size, we are using strapi CDN to fetch them rest already in the codebase
  silverTier: 'Silver-Tier.png',
  platinumTier: 'Platinum-Tier.png',

  voucherSuccessIcon: 'voucherSuccessIcon.png',
  voucherIconNew: 'voucherIconNew.png',
  bogoIcon: 'bogoIcon.png',
  comboSetIcon: 'comboSetIcon.png',
  multibuyIcon: 'multibuyIcon.png',
  proPointIcon: 'proPointIcon.png',
  voucherIcon: 'voucherIcon.png'
};

export const ComplexPromotionIconMap: Record<string, string> = {
  [ComplexPromotionType.COMBO_SET]: LOYALTY_AND_CAMPAIGN_CDN_FILE_NAMES.comboSetIcon,
  [ComplexPromotionType.MIX_MATCH]: LOYALTY_AND_CAMPAIGN_CDN_FILE_NAMES.comboSetIcon,
  [ComplexPromotionType.MULTI_BUY]: LOYALTY_AND_CAMPAIGN_CDN_FILE_NAMES.multibuyIcon,
  [ComplexPromotionType.BOGO]: LOYALTY_AND_CAMPAIGN_CDN_FILE_NAMES.bogoIcon
};

export const fallbackImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAABwCAMAAADxPgR5AAAAIVBMVEVMaXHn5+fo6Ojo6Ojo6Ojo6Ojo6Ojn5+fp6enf39/o6OjJcEQwAAAACnRSTlMAhmE6xd+lIO8QupQMiwAAAAlwSFlzAAALEwAACxMBAJqcGAAAA0JJREFUeJztWcmy4yAMRGLn/z94ygJjiJ0pS0Dehb6k4gQ3tBZAUmpjY2Nj44ewAR+eRg3O2JRScpP5IKUEnw+1CemEmcvn6c3G93SVLaVk5xIqJEbr+zUvJFTe9oyFzwJqr+dLqpSKpKCNLZ/R9GUNoVLucg5P5JlOKVzgpRcj+aq9yXtz4Xmq6qzh8VlwPH6K0kmeYyMt9dKQ9O0iZh5oaRD7BeIin6nmCtjHnV2mqFIqHgkgdIrCQkVV1i+1S6IHS4KigDJONWGEz5S3aolEESHTXw60yoopaUQ4t4tlHvO4TVwZbhUoFisClHS+XFOCWU+ncuoMxjjAX7CphZtDQUQEAEQdn7Y/f/6q5kCXSCMEQ+89N/iooTm2JYPj4Y/dwYxgnT62IxuxJStwY5T+Tpc5abXPv0EcPRkeWjkAAPewIlpx+fX87gcTiqm+opRG15HaNjA8ZmsHofuUc+BtvtrVFHN7M1o5I+0Jj/eXvJRyIn2cpvXC09L3qX6POiBd+ISkm0gaEO1X+XDWPIjvVTLNhYA36KJ3JPAXsz3e7JDHRydbfQt//V5UwyNsh+jAvQFGvv2bu0K++lI6c5zhwFa0mJ30dMd8/Wu/Qa6mzQCKf+5mG5sJc3f0/pr0FpZpRFdNKLB//4J3OOx2Xd4F5QkQEwov78A0/GECP3I+g0341YY/ktT82mnMFRYGJEdqxwwL7v//ntAw89Pw7cgwCYeLg5ZZuBkmTCklzv9H663+OHItHTA84TBWPEO2SbheNuzlbiwQDXv4oJsGtkDCk0UzOiw+53VAQVQNlemdIDMOZVMr8PERI2pJ2qCCoTASUeTi7AvQqP1RnE51EuVFuaZOuNXIrk1K3qbRwthHsX8L3caK0zC5Ddv4KHMZ8VyjfIFlskxHhYEFSmpYXlKC+E/B7ZWgdqAGzS0MgqiQ+Dnj9/Vd4htroGhOfTcXg+MQYfbUd+26SZ1SSHe7RATnoCn2185smNAPgo+OS7yaNVTyy9C5nI/jfLV9Ud5emydNk+Gcw4z1tRzBuL5NQpSmtmTuLQ4pvPtkAUQqg7eY2irFtqV3vrm2aGgOsxvPuqgZoBHu9B97bwptbGxsbKhl+AeC/S/pHG5omAAAAABJRU5ErkJggg==';
